"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _admin = require("../../../../selectors/admin.js");
var _cccisdFormik = require("cccisd-formik");
var _MultiCheckbox = _interopRequireDefault(require("../MultiCheckbox"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AssignmentForm = function AssignmentForm(props) {
  var values = props.values,
    setFieldValue = props.setFieldValue;
  var isInitialMount = (0, _react.useRef)(true);
  var adminState = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin;
  });
  var assignmentList = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectActiveAssignments)(adminState);
  });
  var visibleDeploymentIds = adminState.visibleDeploymentIds;
  var _useMemo = (0, _react.useMemo)(function () {
      var adjustedState = (0, _immutabilityHelper["default"])(adminState, {
        currentQuerySettings: {
          assignmentId: {
            $set: Number(values.assignmentId)
          }
        }
      });
      var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(adjustedState);
      var surveyList = (0, _admin.getCurrentQueryAssignmentActiveSurveys)(adjustedState);
      return {
        deploymentOptions: deploymentList.map(function (item) {
          return {
            value: item.deploymentId,
            label: item.label
          };
        }),
        surveyOptions: surveyList.map(function (item) {
          return {
            value: item.surveyHandle,
            label: item.label
          };
        })
      };
    }, [adminState, values.assignmentId]),
    deploymentOptions = _useMemo.deploymentOptions,
    surveyOptions = _useMemo.surveyOptions;
  var assignmentOptions = (0, _react.useMemo)(function () {
    if (!visibleDeploymentIds) {
      return assignmentList.map(function (item) {
        return {
          value: item.assignmentId,
          label: item.label
        };
      });
    }
    var deploymentIdsSet = new Set(visibleDeploymentIds);
    return assignmentList.filter(function (item) {
      return item.deploymentList.some(function (deployment) {
        return deploymentIdsSet.has(deployment.deploymentId);
      });
    }).map(function (item) {
      return {
        value: item.assignmentId,
        label: item.label
      };
    });
  }, [assignmentList, visibleDeploymentIds]);
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setFieldValue('deploymentIds', 'all');
    setFieldValue('surveyHandles', 'all');
    setFieldValue('filter', null);
  }, [deploymentOptions, surveyOptions, values.assignmentId]);
  if (assignmentOptions.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "There are no active Quests that contain data collection waves."), " You can create a new data collection wave from the Deploy tab.");
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "assignmentId",
    component: _cccisdFormik.CccisdSelect,
    label: "Quest",
    options: assignmentOptions,
    style: {
      width: 'auto',
      maxWidth: '100%'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '0.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "deploymentIds",
    component: _MultiCheckbox["default"],
    label: "Data Collection Waves",
    options: deploymentOptions
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "surveyHandles",
    component: _MultiCheckbox["default"],
    label: "Surveys",
    options: surveyOptions
  }));
};
var _default = AssignmentForm;
exports["default"] = _default;